import * as React from "react"
import { Container, Row, Col, Spinner, Table, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import GovPoolStatisticsDetailsGet from "../../../api/Randoms/GovPoolStatisticsDetailsGet"
import GovPoolStatisticsDetails from "../../../api/Randoms/RandomsModel/GovPoolStatisticsDetails"
import { SelectionReportPrint } from "../../../api/Randoms/SelectionReportPrint"

interface PoolStatisticsProps {
  poolId: number
  poolName: string
}

interface PoolStatisticsState {
  statisticsLoading: boolean
  statistics?: GovPoolStatisticsDetails[]
}

export default class PoolStatistics extends React.PureComponent<PoolStatisticsProps, PoolStatisticsState> {
  state: PoolStatisticsState = {
    statisticsLoading: false
  }

  statisticsSubscription?: Subscription
  printSubscription?: Subscription

  componentDidMount() {
    this.setState({ statisticsLoading: true })
    this.statisticsSubscription = GovPoolStatisticsDetailsGet(this.props.poolId).subscribe(
      (data: GovPoolStatisticsDetails[]) =>
          this.setState({
            statisticsLoading: false,
            statistics: data
          }),
      () => this.setState({ statisticsLoading: false }))
  }

  componentWillUnmount() {
    this.printSubscription && this.printSubscription.unsubscribe()
    this.statisticsSubscription && this.statisticsSubscription.unsubscribe()
  }

  print(base64pdf: string) {
    const pdfWindow = window.open("")
    if (pdfWindow) {
      pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(base64pdf) + "'></iframe>")
    }
  }

  handleGroupSelectionClick = (row: GovPoolStatisticsDetails) => {
    this.printSubscription && this.printSubscription.unsubscribe()
    this.printSubscription = SelectionReportPrint(row.Period).subscribe(
      data => this.print(data),
      error => toast.error(error)
    )
  }

  renderRows = () => {
    const { statistics } = this.state
    if (statistics && statistics.length) {
      return statistics.map((row: GovPoolStatisticsDetails, i: number) =>
        <tr key={i}>
          <td><Button variant="link" onClick={() => this.handleGroupSelectionClick(row)} className="p-0">{row.Period}</Button></td>
          <td className="text-center">{row.GroupSize}</td>
          <td className="text-center">{row.SelectionDate}</td>
          <td className="text-center">{row.TestsCompleted === 0 ? "" : row.TestsCompleted}</td>
          <td className="text-center">{row.NoShow === 0 ? "" : row.NoShow}</td>
        </tr>)
    } else {
      return <tr><td colSpan={5}>NO DATA FOUND</td></tr>
    }
  }

  render() {
    return <>
      <Container fluid className="grid-container">
        <Row>
          <Col>
            <h5>TESTING PERIOD BREAKDOWN</h5>
          </Col>
        </Row>
        <Table responsive className="table-sm dark">
          <thead>
            <tr className="text-normal">
              <th className="border-bottom-0">Period</th>
              <th className="border-bottom-0 text-center">Group Size</th>
              <th className="border-bottom-0 text-center">Selection Date</th>
              <th className="border-bottom-0 text-center">Tests Completed</th>
              <th className="border-bottom-0 text-center">No Show</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.statisticsLoading ?
                <tr>
                  <td className="text-center" colSpan={5}>
                    <Spinner animation="border" variant="secondary" />
                  </td>
                </tr> : this.renderRows()
            }
          </tbody>
        </Table>
      </Container>
    </>
  }
}
